import { createContext, useContext, useState } from 'react'

export enum NavigationDirection {
  initial = 'initial',
  navigate = 'navigate',
  prev = 'prev',
}

export const navigationDirectionContext = createContext({
  direction: NavigationDirection.initial,
})

export const useNavigationDirection = () => {
  const ctx = useContext(navigationDirectionContext)
  return ctx.direction
}

export const useInitialNavigationDirection = () => {
  const direction = useNavigationDirection()
  const [initialDirection] = useState(direction)
  return initialDirection
}
